
/**
 * Detects potential infinite recursion in a function.
 * @param {number} maxDepth Maximum number of times the function can be called recursively before throwing an error.
 */
export function detectRecursion (maxDepth = 1) {
  const stack = new Error().stack
  const functions = stack.split('\n').slice(1).map(line =>
    // Chrome:  at useExperiment (webpack-internal:///./shared/composables/experiment.js:50:73)
    // Firefox: useExperiment@webpack-internal:///./shared/composables/experiment.js:50:73
    // Safari:  useExperiment@
    (line.trim().match(/at (\S+)/) ?? line.trim().match(/(\S+)@/))?.[1] ?? 'unknown'
  )
  // Look for the last two function names in the stack trace, excluding the current function.
  const numCandidates = 2
  const candidates = functions[0] === 'detectRecursion'
    ? functions.slice(1, numCandidates + 1)
    : functions.slice(0, numCandidates)
  const occurrences = functions.reduce((acc, fn) => {
    if (candidates.includes(fn)) {
      acc[fn] = (acc[fn] || 0) + 1
    }
    return acc
  }, {})
  const funcName = Object.keys(occurrences).find(func => occurrences[func] > maxDepth)
  if (funcName) {
    throw new Error(`Potential infinite recursion detected in ${funcName}.`)
  }
}
